import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Χρησιμοποιούμε cookies',
    description:
      'Χρησιμοποιούμε cookies και παρόμοιες τεχνολογίες για τη λειτουργία αυτής της εμπειρίας. Τα απολύτως απαραίτητα cookies είναι πάντα ενεργά.',
    allow_label: 'Αποδοχή όλων των cookies',
    reject_label: 'Μόνο τα απολύτως απαραίτητα',
    settings_label: 'Ρυθμίσεις cookies',
    policy_link_label: 'Πολιτική απορρήτου και cookies',
    categories_label: 'Κατηγορίες',
    always_on_label: 'Πάντα ενεργά',
    required_label: 'Υποχρεωτικά',
    save_preferences_label: 'Αποθήκευση προτιμήσεων',
    close_label: 'Κλείσιμο',
    allow_all_optional_categories_label: 'Να επιτρέπονται όλες οι προαιρετικές κατηγορίες',
    settings_title: 'Ρυθμίσεις cookies',
    settings_description:
      'Χρησιμοποιούμε cookies και παρόμοιες τεχνολογίες για τη λειτουργία αυτής της εμπειρίας. Τα απολύτως απαραίτητα cookies είναι πάντα ενεργά.',
    save_error: 'Δεν ήταν δυνατή η αποθήκευση της επιλογής απορρήτου σας. Δοκιμάστε ξανά.'
  },
  categories: {
    strictly_necessary: {
      name: 'Απολύτως απαραίτητα',
      purpose: 'Απαιτούνται για τη λειτουργία αυτής της εμπειρίας και δεν μπορούν να απενεργοποιηθούν.'
    },
    analytics: {
      name: 'Αναλυτικά στοιχεία',
      purpose: 'Μετρούν πώς χρησιμοποιούν οι επισκέπτες αυτή την εμπειρία, ώστε να βελτιωθεί η απόδοση.'
    },
    marketing: {
      name: 'Μάρκετινγκ',
      purpose: 'Υποστηρίζουν τη διαφήμιση και το μάρκετινγκ που επιλέγει ο διοργανωτής.'
    }
  }
};

export default locale;
